import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import Grid from '@mui/material/Grid';
;
var StyledComponent = styled(function (props) {
    var id = props.id, sx = props.sx, rest = __rest(props, ["id", "sx"]);
    if (sx)
        console.error('The sx prop is not used in StyledComponent');
    return _jsx(Grid, __assign({ id: id }, rest));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
